export default "__VITE_ASSET__90594354__"